export const TICKER_FALLBACK = {
  'BTC-USD':  { bg: '#f7931a', color: '#fff' },
  'ETH-USD':  { bg: '#627eea', color: '#fff' },
  'SOL-USD':  { bg: '#9945ff', color: '#fff' },
  'XRP-USD':  { bg: '#346aa9', color: '#fff' },
  'EURUSD=X': { bg: '#003f8a', color: '#fff' },
  '^GDAXI':   { bg: '#2563eb', color: '#fff' },
  '^DJI':     { bg: '#1a2333', color: '#fff' },
  '^IXIC':    { bg: '#2563eb', color: '#fff' },
};
